import React from "react";
import { Carousel, Col, Image, Row } from "react-bootstrap";
import Banner1 from "../../../assets/images/coi_banner_1.jpg";
import Banner2 from "../../../assets/images/coi_banner_2.jpg";
import Banner3 from "../../../assets/images/coi_banner_3.jpg";
import { useHistory } from "react-router-dom";

const ConflictOfInterest = () => {
  const history = useHistory();
  return (
    <>
      <Row
        style={{
          padding: '0px 4px 16px 12px'
        }}
      >
        <Col xs={9} style={{ paddingLeft: 0, paddingTop: 5 }}>
          <div
            style={{
              fontSize: '17px',
              fontWeight: 'bold',
              fontStretch: 'normal'
            }}
          >
            <h4>Conflict of Interest</h4>
          </div>
          <div style={{ fontSize: '14px' }}>
            Conflict of Interest (COI) is a situation where the personal
            interest of an employee could lead to decisions not in the best
            interest of Mahindra where interest can be defined as any commitment
            or duty and responsibility which is associated with any particular
            role of the individual. <br />
            To know more read the relevant session of the Code of Conduct.
          </div>
        </Col>
        {/* {isPermited(8, 3) && ( */}
        <Col className='desk ms-auto my-auto' xs='auto'>
          <span style={{ float: 'right' }}>
            <button
              className='button'
              onClick={() => history.push('/disclosures')}
              style={{
                padding: '4px 25px',
                fontFamily: 'Saira',
                fontSize: '12px',
                fontWeight: 500,
                fontStretch: 'normal',
                fontStyle: 'normal'
              }}
            >
              DECLARE A CONFLICT{' '}
            </button>
          </span>
        </Col>
        {/* )} */}
      </Row>
      <Carousel data-bs-theme='dark' interval={2000} controls={false}>
        <Carousel.Item>
          <Image src={Banner1} style={{ width: '100%', height: '100%' }} />
        </Carousel.Item>
        <Carousel.Item>
          <Image src={Banner2} style={{ width: '100%', height: '100%' }} />
        </Carousel.Item>
        <Carousel.Item>
          <Image src={Banner3} style={{ width: '100%', height: '100%' }} />
        </Carousel.Item>
      </Carousel>
    </>
  );
};

export default ConflictOfInterest;
